export default "__VITE_ASSET__Dc_3iLh2__"